// extracted by mini-css-extract-plugin
export default {"hold":"Card_hold__oGIPe","star":"Card_star__xhght","head":"Card_head__LyieA","txt":"Card_txt__oFiPJ","btn":"Card_btn__qg0J6"};